import {Component, OnInit} from '@angular/core';
import {BreadcrumbsService} from '../../shared/components/breadcrumbs/breadcrumbs.service';

@Component({
  selector: 'kkk-puppet',
  templateUrl: './puppet.component.html',
  styleUrls: ['./puppet.component.scss']
})
export class PuppetComponent implements OnInit {
    constructor(
        private _breadcrumbs: BreadcrumbsService,
    ) {
    }

    ngOnInit() {
        this._breadcrumbs
            .start({name: 'Mit teszünk?', instructions: ['/mit-teszunk']})
            .add({name: 'Missziók', instructions: ['/missziok']})
            .add({name: 'Báb misszió'});
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/what-we-do/puppet/puppet.component.ts